// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2yX-u","noInteraction":"EventWrapper_noInteraction__17APj","pointerPassthrough":"EventWrapper_pointerPassthrough__3KijX"};